import { useEffect, useState } from 'react'

import { debounce } from '@app/utils/debounce'

const defaultSize: [number, number] = [800, 600]

export const useSize = (interval = 500): [number, number] => {
  if (!IS_BROWSER) return defaultSize

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const [size, setSize] = useState<[number, number]>(() => [document.documentElement.clientWidth, document.documentElement.clientHeight])

  // eslint-disable-next-line react-hooks/rules-of-hooks
  useEffect(() => {
    const handler = debounce(() => {
      setSize([document.documentElement.clientWidth, document.documentElement.clientHeight])
    }, interval)

    window.addEventListener('resize', handler)
    return () => {
      window.removeEventListener('resize', handler)
    }
  }, [interval])

  return size
}
